export const AVAILABLE_LOCALES = [
    'en',
    'sv'
];

export const AVAILABLE_LOCALE_NAMES = {
    'en': 'English',
    'sv': 'Svenska'
};
